import { useInView } from '../hooks/useInView';
import { services } from '../data/mock';
import { BookOpen, GraduationCap, ShieldCheck, PenTool, Check, Languages, School } from 'lucide-react';

const iconMap = { BookOpen, GraduationCap, ShieldCheck, PenTool, Languages, School };

export const ServicesSection = () => {
  const [ref, isInView] = useInView();

  return (
    <section id="services" className="relative py-24 bg-[#F8FAFC]">
      {/* Top decorative line */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#D4A853]/30 to-transparent" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" ref={ref}>
        {/* Section Header */}
        <div
          className={`text-center mb-16 transition-[opacity,transform] duration-700 ${
            isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <span className="text-[#D4A853] font-semibold text-sm uppercase tracking-[0.2em]">Our Services</span>
          <h2
            className="text-4xl sm:text-5xl font-bold text-[#0A1628] mt-3 mb-5"
            style={{ fontFamily: 'Poppins, sans-serif' }}
          >
            End-to-End Study Abroad Support
          </h2>
          <p className="text-slate-500 text-lg max-w-2xl mx-auto leading-relaxed">
            From IELTS coaching to pre-departure briefing, we provide comprehensive support at every step of your study abroad journey.
          </p>
        </div>

        {/* Service Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => {
            const Icon = iconMap[service.icon];
            return (
              <div
                key={service.title}
                className={`group relative bg-white rounded-2xl p-8 border border-slate-100 hover:border-[#D4A853]/30 transition-[opacity,transform,border-color,box-shadow] duration-500 hover:-translate-y-1 hover:shadow-xl hover:shadow-[#0A1628]/5 ${
                  isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                }`}
                style={{ transitionDelay: `${index * 150}ms` }}
              >
                <div className="flex items-start gap-5">
                  <div className="w-14 h-14 bg-[#0A1628] rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-[#D4A853] transition-colors duration-400">
                    <Icon className="w-7 h-7 text-[#E8C87A] group-hover:text-[#0A1628] transition-colors duration-400" />
                  </div>
                  <div className="flex-1">
                    <h3
                      className="text-xl font-bold text-[#0A1628] mb-3"
                      style={{ fontFamily: 'Poppins, sans-serif' }}
                    >
                      {service.title}
                    </h3>
                    <p className="text-slate-500 leading-relaxed mb-5">{service.description}</p>
                    <div className="grid grid-cols-2 gap-2.5">
                      {service.features.map((feature) => (
                        <div key={feature} className="flex items-center gap-2">
                          <div className="w-5 h-5 rounded-full bg-[#D4A853]/10 flex items-center justify-center flex-shrink-0">
                            <Check className="w-3 h-3 text-[#D4A853]" />
                          </div>
                          <span className="text-sm text-slate-600">{feature}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
